import { FC } from 'react';
import { Button, Col, Form, Input, InputNumber, message, Row, Spin } from "antd";
import * as React from "react";
import restful from '../../restful';
import SelectRoleField from '../fields/select-role-field';
import Password from 'antd/lib/input/Password';
import SelectPublishField from '../fields/select-publish-field';
import UploadFileField from '../fields/upload-file-field';
import SelectMarketField from '../fields/select-market-field';

interface Prop { id: string | null }

const CreditPackForm: FC<Prop> = ({ id }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = React.useState(false)

	React.useEffect(() => {
		if (id === null) return
		setLoading(true)
		restful.get('credit-packs/' + id + "/form")
			.then((res) => {
				res.data.result.form.published = res.data.result.form.published + ''
				form.setFieldsValue(res.data.result.form)
			})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));;
	}, [])

	function onFinish(data: any) {
		setLoading(true)
		restful.request({
			data,
			method: id ? "PUT" : "POST",
			url: id ? `/credit-packs/${id}` : "/credit-packs"
		}).then((res) => {
			if (id === null) form.resetFields()
			message.success("انجام شد")
		})
			.catch((err) => message.error(err.message))
			.finally(() => setLoading(false));
	}

	return (
		<Spin spinning={loading} >
			<Form form={form} onFinish={onFinish} layout="vertical" autoComplete='off'>
				<Row gutter={16}>


					<Col xs={24} md={12}  >
						<Form.Item name="title" label="عنوان"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Input />
						</Form.Item>
					</Col>




					<Col xs={24} md={12}  >
						<Form.Item name="marketProductId" label="کد محصول"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<Input />
						</Form.Item>
					</Col>



					<Col xs={24} md={12}  >
						<Form.Item name="level" label="سطح"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<InputNumber style={{ width: "100%" }} />
						</Form.Item>
					</Col>




					<Col xs={24} md={12}  >
						<Form.Item name="market" label="مارکت"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<SelectMarketField />
						</Form.Item>
					</Col>



					<Col xs={24} md={12}  >
						<Form.Item name="coinGift" label="سکه هدیه"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<InputNumber style={{ width: "100%" }} />
						</Form.Item>
					</Col>



					<Col xs={24} md={12}  >
						<Form.Item name="cost" label="مبلغ"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<InputNumber style={{ width: "100%" }} />
						</Form.Item>
					</Col>



					<Col xs={24} md={12}  >
						<Form.Item name="published" label="انتشار"
							rules={[
								{ required: id === null, message: "این فیلد ضروری است" },
							]}
						>
							<SelectPublishField />
						</Form.Item>
					</Col>



					<Col span={24} style={{ textAlign: 'left' }}>
						<Button type="primary" htmlType="submit">ثبت</Button>
					</Col>
				</Row>
			</Form>
		</Spin>
	)
}

export default CreditPackForm;
